// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: HuQBdhN9Rcl
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingBusinessDetailsRetryManual.module.css"; // plasmic-import: HuQBdhN9Rcl/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingBusinessDetailsRetryManual__VariantProps =
  new Array();

export const PlasmicOnboardingBusinessDetailsRetryManual__ArgProps =
  new Array();

const $$ = {};

function PlasmicOnboardingBusinessDetailsRetryManual__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "firstName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "lastName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "legalBusinessName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "displayBusinessName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "ein.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "textbox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "United States"
      },
      {
        path: "address1.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "city.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "zip.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "ssn.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "textbox2.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "United States"
      },
      {
        path: "paddress1.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "pcity.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "pzip.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__sxEz)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__aL438
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__bAxWe)}>
            <div className={classNames(projectcss.all, sty.freeBox__nlb1B)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___7Bv1T)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__nGmWf)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___1SaEl)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___1F99V)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__zt2UP)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__wbqIz)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__q0Ebi)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___4Y5Yh)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__lUj62)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__ystFp)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__nBeeb)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__fNthy)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox___3Pp6G)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__tcNU
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ngeXq
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__zs8Y0
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__knp04
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__rxDWw
                )}
              >
                {"Retry & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__w9T)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__rdMwW
                )}
              >
                {
                  "It looks like your account wasn't immediately approved by our compliance partners. Please try again by re-entering your information below. "
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__h1V7Y)}>
                <div className={classNames(projectcss.all, sty.freeBox__hgtr1)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__qs6Or
                    )}
                  >
                    {"First Name"}
                  </div>
                  <input
                    data-plasmic-name={"firstName"}
                    data-plasmic-override={overrides.firstName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.firstName
                    )}
                    onChange={e => {
                      p.generateStateOnChangeProp($state, [
                        "firstName",
                        "value"
                      ])(e.target.value);
                    }}
                    placeholder={"First"}
                    ref={ref => {
                      $refs["firstName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      p.generateStateValueProp($state, [
                        "firstName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__ffsf)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ndN4I
                    )}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    data-plasmic-name={"lastName"}
                    data-plasmic-override={overrides.lastName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.lastName
                    )}
                    onChange={e => {
                      p.generateStateOnChangeProp($state, [
                        "lastName",
                        "value"
                      ])(e.target.value);
                    }}
                    placeholder={"Last"}
                    ref={ref => {
                      $refs["lastName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      p.generateStateValueProp($state, ["lastName", "value"]) ??
                      ""
                    }
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__d49Vr)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___6WHes
                  )}
                >
                  {"Address"}
                </div>
                <input
                  data-plasmic-name={"textbox2"}
                  data-plasmic-override={overrides.textbox2}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.textbox2
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["textbox2", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"12-3456789"}
                  ref={ref => {
                    $refs["textbox2"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["textbox2", "value"]) ??
                    ""
                  }
                />

                <input
                  data-plasmic-name={"paddress1"}
                  data-plasmic-override={overrides.paddress1}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.paddress1
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["paddress1", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"Address Line"}
                  ref={ref => {
                    $refs["paddress1"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["paddress1", "value"]) ??
                    ""
                  }
                />

                <input
                  data-plasmic-name={"pcity"}
                  data-plasmic-override={overrides.pcity}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.pcity
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["pcity", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["pcity"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["pcity", "value"]) ?? ""
                  }
                />

                <input
                  data-plasmic-name={"pzip"}
                  data-plasmic-override={overrides.pzip}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.pzip
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["pzip", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"ZIP"}
                  ref={ref => {
                    $refs["pzip"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["pzip", "value"]) ?? ""
                  }
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__jx0Ib)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__w0DFj
                  )}
                >
                  {"Date of Birth"}
                </div>
                <div
                  data-plasmic-name={"dob"}
                  data-plasmic-override={overrides.dob}
                  className={classNames(projectcss.all, sty.dob)}
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___1Cz0K)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__qIhdr
                  )}
                >
                  {"Social Security Number (9 Digits)"}
                </div>
                <input
                  data-plasmic-name={"ssn"}
                  data-plasmic-override={overrides.ssn}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.ssn
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["ssn", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"123-45-6789"}
                  ref={ref => {
                    $refs["ssn"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["ssn", "value"]) ?? ""
                  }
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__ubAl1)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___1WEQb
                  )}
                >
                  {"Legal Business Name"}
                </div>
                <input
                  data-plasmic-name={"legalBusinessName"}
                  data-plasmic-override={overrides.legalBusinessName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.legalBusinessName
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, [
                      "legalBusinessName",
                      "value"
                    ])(e.target.value);
                  }}
                  placeholder={"Company"}
                  ref={ref => {
                    $refs["legalBusinessName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, [
                      "legalBusinessName",
                      "value"
                    ]) ?? ""
                  }
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__a2XQ6)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__vXbi
                  )}
                >
                  {"Display Business Name"}
                </div>
                <input
                  data-plasmic-name={"displayBusinessName"}
                  data-plasmic-override={overrides.displayBusinessName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.displayBusinessName
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, [
                      "displayBusinessName",
                      "value"
                    ])(e.target.value);
                  }}
                  placeholder={""}
                  ref={ref => {
                    $refs["displayBusinessName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, [
                      "displayBusinessName",
                      "value"
                    ]) ?? ""
                  }
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___5IFb)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__iRpdu
                  )}
                >
                  {"Employer Identification Number (EIN)"}
                </div>
                <input
                  data-plasmic-name={"ein"}
                  data-plasmic-override={overrides.ein}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.ein
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["ein", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"12-3456789"}
                  ref={ref => {
                    $refs["ein"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["ein", "value"]) ?? ""
                  }
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__bMsX)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__wyPb
                  )}
                >
                  {"Registered Business Address"}
                </div>
                <input
                  data-plasmic-name={"textbox"}
                  data-plasmic-override={overrides.textbox}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.textbox
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["textbox", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"12-3456789"}
                  ref={ref => {
                    $refs["textbox"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["textbox", "value"]) ?? ""
                  }
                />

                <input
                  data-plasmic-name={"address1"}
                  data-plasmic-override={overrides.address1}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.address1
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["address1", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"Address Line 1"}
                  ref={ref => {
                    $refs["address1"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["address1", "value"]) ??
                    ""
                  }
                />

                <input
                  data-plasmic-name={"city"}
                  data-plasmic-override={overrides.city}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.city
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["city", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["city"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["city", "value"]) ?? ""
                  }
                />

                <input
                  data-plasmic-name={"zip"}
                  data-plasmic-override={overrides.zip}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.zip
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["zip", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"ZIP"}
                  ref={ref => {
                    $refs["zip"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["zip", "value"]) ?? ""
                  }
                />
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Incorrect email or password"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__cHhzv
                  )}
                >
                  {"Submit"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "firstName",
    "lastName",
    "textbox2",
    "paddress1",
    "pcity",
    "pzip",
    "dob",
    "ssn",
    "legalBusinessName",
    "displayBusinessName",
    "ein",
    "textbox",
    "address1",
    "city",
    "zip",
    "errorText",
    "continueButton"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  firstName: ["firstName"],
  lastName: ["lastName"],
  textbox2: ["textbox2"],
  paddress1: ["paddress1"],
  pcity: ["pcity"],
  pzip: ["pzip"],
  dob: ["dob"],
  ssn: ["ssn"],
  legalBusinessName: ["legalBusinessName"],
  displayBusinessName: ["displayBusinessName"],
  ein: ["ein"],
  textbox: ["textbox"],
  address1: ["address1"],
  city: ["city"],
  zip: ["zip"],
  errorText: ["errorText"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicOnboardingBusinessDetailsRetryManual__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingBusinessDetailsRetryManual__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingBusinessDetailsRetryManual__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingBusinessDetailsRetryManual";
  } else {
    func.displayName = `PlasmicOnboardingBusinessDetailsRetryManual.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingBusinessDetailsRetryManual = Object.assign(
  // Top-level PlasmicOnboardingBusinessDetailsRetryManual renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    textbox2: makeNodeComponent("textbox2"),
    paddress1: makeNodeComponent("paddress1"),
    pcity: makeNodeComponent("pcity"),
    pzip: makeNodeComponent("pzip"),
    dob: makeNodeComponent("dob"),
    ssn: makeNodeComponent("ssn"),
    legalBusinessName: makeNodeComponent("legalBusinessName"),
    displayBusinessName: makeNodeComponent("displayBusinessName"),
    ein: makeNodeComponent("ein"),
    textbox: makeNodeComponent("textbox"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    zip: makeNodeComponent("zip"),
    errorText: makeNodeComponent("errorText"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingBusinessDetailsRetryManual
    internalVariantProps:
      PlasmicOnboardingBusinessDetailsRetryManual__VariantProps,
    internalArgProps: PlasmicOnboardingBusinessDetailsRetryManual__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingBusinessDetailsRetryManual;
/* prettier-ignore-end */
